/* AVRA_NAV_CLICK (2026-09-20)
   "Fine Jewelry" in the desktop nav is already a real link to
   /collections/all, but initMega() in avra-theme.js calls preventDefault()
   on its click and toggles the mega panel instead, so the link never fires.

   The panel already opens on mouseenter, so on a mouse the click-toggle is
   redundant. It is NOT redundant for a keyboard user: Enter fires a click,
   and that toggle is currently the only way to open the mega menu without a
   pointer. So the two cases are separated rather than the handler removed.

   This listens on document in the CAPTURE phase, which always runs before a
   listener bound to the element itself, whichever was registered first. A
   real pointer click (e.detail >= 1) is stopped before it reaches initMega
   and navigates instead. A keyboard activation reports e.detail === 0 and is
   left completely alone, so Enter still opens the panel.

   Mobile is untouched: the centred nav is display:none under 880px and the
   drawer handles navigation there.

   Delete this file and its <script> tag in layout/theme.liquid and the theme
   returns to its previous behaviour exactly. */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-mega] .nav__trigger') : null;
      if (!t) return;
      if (window.innerWidth <= 880) return; /* drawer territory */
      if (e.detail === 0) return;           /* keyboard - leave the toggle alone */

      var href = t.getAttribute('href');
      if (!href || href === '#') return;

      e.stopPropagation();                  /* initMega never sees this click */
      window.location.href = href;
    },
    true
  );
})();
